// import "./new.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import Select from "react-select";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import { Invigilation_attendanceInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const TSOptions = [
//   { value: "Present", label: "Present" },
//   { value: "Absent", label: "Absent" },
//   { value: "Late", label: "Late" },
//   { value: "Replacement", label: "Replacement" },
// ];

// const InvigilationAttendanceNew = ({ title }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [inputValues, setInputValues] = useState({});
//   const [notification, setNotification] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedDay, setSelectedDay] = useState(null);
//   const [selectedUser, setSelectedUser] = useState([]);
//   const [useroptions, setUseroptions] = useState([]);
//   const [selectedSubject, setSelectedSubject] = useState([]);
//   const [selectedUser_rep, setSelectedUser_rep] = useState([]);
//   const [selectedSubject_rep, setSelectedSubject_rep] = useState([]);
//   const [selectedUser_replac, setSelectedUser_replac] = useState([]);
//   const [selectedSubject_replac, setSelectedSubject_replac] = useState([]);
//   const [Invigilation_status, setInvigilation_status] = useState([]);
//   const [Subjectoptions, setSubjectoptions] = useState([]);
//   const [selectedClass, setSelectedClass] = useState([]);
//   const [selectedtt_id, setSelectedtt_id] = useState([]);
//   const [Classoptions, setClassoptions] = useState([]);
//   const [isNotificationVisible, setIsNotificationVisible] = useState(false);
//   const center_id = localStorage.getItem("center_id");
//   const timetableId = location.pathname.match(
//     /\/Invigilation-attendance\/new\/(\d+)/
//   )?.[1];
//   console.log("Extracted ID:", timetableId);

//   console.log("Current Path:", location.pathname);

//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   useEffect(() => {
//     const fetchTimetable = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/timetable/${timetableId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         const snames = data.data.Invigilation_names;
//         const sid = data.data.Invigilation_id;
//         // console.log("abbas1",abbas);
//         const namelist = [];
//         const name = snames;
//         console.log(name);
//         const id = sid; // Access the "name" property
//         namelist.push({ value: id, label: name });
//         const Subject = data.data.subject_names;
//         const tid = data.data.subject_id;
//         // console.log("abbas1",abbas);
//         const namelist_t = [];
//         namelist_t.push({ value: tid, label: Subject });
//         const Class = data.data.class_names;
//         const aid = data.data.class_id;
//         // console.log("abbas1",abbas);
//         const namelist_a = [];
//         namelist_a.push({ value: aid, label: Class });
//         setInputValues(data.data);
//         const status = data.data.status;
//         const day = data.data.day;
//         console.log(status);
//         if (status == 1) {
//           setSelectedStatus({ value: status, label: "Active" });
//         } else {
//           setSelectedStatus({ value: status, label: "Inactive" });
//         }
//         console.log(day);
//         if (day == "Monday") {
//           setSelectedDay({ value: day, label: "Monday" });
//         } else if (day == "Tuesday") {
//           setSelectedDay({ value: day, label: "Tuesday" });
//         } else if (day == "Wednesday") {
//           setSelectedDay({ value: day, label: "Wednesday" });
//         } else if (day == "Thursday") {
//           setSelectedDay({ value: day, label: "Thursday" });
//         } else if (day == "Friday") {
//           setSelectedDay({ value: day, label: "Friday" });
//         } else if (day == "Saturday") {
//           setSelectedDay({ value: day, label: "Saturday" });
//         } else {
//           setSelectedDay({ value: day, label: "Sunday" });
//         }
//         setSelectedtt_id(data.data.id);
//         setSelectedUser(namelist);
//         setSelectedSubject(namelist_t);
//         setSelectedClass(namelist_a);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (timetableId) {
//       fetchTimetable();
//     }
//   }, [timetableId]);

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleDaySelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       day: selectedOption.value,
//     });
//   };

//   const handleInvigilation_StatusSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       Invigilation_status: selectedOption.value,
//     });
//     if (selectedOption.value == "Present" || selectedOption.value == "Late") {
//       setSelectedSubject_rep({ value: "None", label: "None" });
//       setSelectedUser_rep({ value: "None", label: "None" });
//       setSelectedSubject_replac("None");
//       setSelectedUser_replac("None");
//     } else {
//       setSelectedSubject_rep([]);
//       setSelectedUser_rep([]);
//     }
//     setInvigilation_status(selectedOption.value);
//   };

//   const handleUserSelectChange = (selectedOption) => {
//     setSelectedUser_rep(selectedOption);
//     setInputValues({
//       ...inputValues,
//       user_rep_id: selectedOption.value,
//     });
//     setSelectedUser_replac(selectedOption.value);
//   };
//   useEffect(() => {
//     user_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const user_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setUseroptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleClassSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     class_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const class_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setClassoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setSelectedSubject_rep(selectedOption);
//     setInputValues({
//       ...inputValues,
//       subject_rep_id: selectedOption.value,
//     });
//     setSelectedSubject_replac(selectedOption.value);
//   };
//   useEffect(() => {
//     subject_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const subject_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setSubjectoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();

//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("timetable_id", selectedtt_id);
//     formData.append("Invigilation_status", Invigilation_status);
//     formData.append("date", inputValues.date);
//     formData.append("subject_rep_id", selectedSubject_replac);
//     formData.append("user_rep_id", selectedUser_replac);
//     formData.append("status", inputValues.status || 1);
//     // formData.append("logo", file); // Append the file to FormData

//     try {
//       // Send formData to the server using an HTTP request with multipart/form-data
//       const response = await fetch(`${serverUrl}/add_Invigilation_attendance`, {
//         method: "POST",
//         body: formData, // Use formData here with multipart/form-data
//       });

//       const data = await response.json();
//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }

//         // Clear all input data and roles when error occurs
//         // setInputValues({});
//         // setSelectedUser([]);

//         // Force the component to rerender with the empty state
//         setTimeout(() => {}, 500); // Adding timeout to allow state change
//       } else {
//         toast.success("Invigilation Attendance added successfully!");

//         // Clear form data after success
//         setInputValues({});
//         // setSelectedUser([]);

//         // Navigate to the users page after success
//         setTimeout(() => {
//           navigate("/Invigilation-attendance");
//         }, 1000);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   const showNotification = (message) => {
//     setNotification(message);
//     setIsNotificationVisible(true);

//     // Automatically hide the notification after a certain time (e.g., 3 seconds)
//     setTimeout(() => {
//       setIsNotificationVisible(false);
//       setNotification("");
//     }, 3000); // Adjust the time as needed
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   {Invigilation_attendanceInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       {input.fieldName === "status" ? null : (
//                         <>
//                           <label>{input.label}</label>
//                           {input.fieldName === "Invigilation_status" ? (
//                             <Select
//                               options={TSOptions}
//                               name={input.fieldName}
//                               onChange={handleInvigilation_StatusSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "subject_rep_id" ||
//                             input.fieldName === "user_rep_id" ? (
//                             <Select
//                               options={
//                                 input.fieldName === "subject_rep_id"
//                                   ? Subjectoptions
//                                   : useroptions
//                               }
//                               name={input.fieldName}
//                               value={
//                                 input.fieldName === "subject_rep_id"
//                                   ? selectedSubject_rep
//                                   : selectedUser_rep
//                               }
//                               onChange={
//                                 input.fieldName === "subject_rep_id"
//                                   ? handleSubjectSelectChange
//                                   : handleUserSelectChange
//                               }
//                               required
//                             />
//                           ) : input.fieldName === "subject_id" ? (
//                             <input
//                               type="text"
//                               value={
//                                 selectedSubject.length > 0
//                                   ? selectedSubject[0].label
//                                   : ""
//                               }
//                               readOnly
//                               className="read-only-input"
//                             />
//                           ) : input.fieldName === "user_id" ? (
//                             <input
//                               type="text"
//                               value={
//                                 selectedUser.length > 0
//                                   ? selectedUser[0].label
//                                   : ""
//                               }
//                               readOnly
//                               className="read-only-input"
//                             />
//                           ) : input.fieldName === "class_id" ? (
//                             <input
//                               type="text"
//                               value={
//                                 selectedClass.length > 0
//                                   ? selectedClass[0].label
//                                   : ""
//                               }
//                               readOnly
//                               className="read-only-input"
//                             />
//                           ) : input.fieldName === "day" ? (
//                             <input
//                               type="text"
//                               value={selectedDay ? selectedDay.label : ""}
//                               readOnly
//                               className="read-only-input"
//                             />
//                           ) : input.fieldName === "start_slot_time" ||
//                             input.fieldName === "end_slot_time" ? (
//                             <input
//                               type="text"
//                               value={inputValues[input.fieldName] || ""}
//                               readOnly
//                               className="read-only-input"
//                             />
//                           ) : (
//                             <input
//                               type={input.type}
//                               placeholder={input.placeholder}
//                               name={input.fieldName}
//                               value={inputValues[input.fieldName] || ""}
//                               onChange={handleInputChange}
//                               required
//                             />
//                           )}
//                         </>
//                       )}
//                     </div>
//                   ))}

//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Send
//                     </button>
//                   </div>
//                 </form>
//                 {isNotificationVisible && (
//                   <div className="notification">{notification}</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default InvigilationAttendanceNew;

import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const StyledSelect = styled(Select)({
  width: "100%",
  "& .select__control": {
    minHeight: 46,
    border: "1px solid #e2e8f0",
    borderRadius: 6,
    backgroundColor: "#f8fafc",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#cbd5e0",
    },
  },
  "& .select__control--is-focused": {
    borderColor: "#7451f8",
    boxShadow: "0 0 0 3px rgba(116, 81, 248, 0.15)",
    backgroundColor: "white",
  },
  "& .select__value-container": {
    padding: "2px 8px",
  },
  "& .select__indicator": {
    padding: "8px",
  },
});

const TSOptions = [
  { value: "Present", label: "Present" },
  { value: "Absent", label: "Absent" },
  { value: "Late", label: "Late" },
  { value: "Replacement", label: "Replacement" },
];

const InvigilationAttendanceNew = ({ title }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({});
  const [useroptions, setUseroptions] = useState([]);
  const [Subjectoptions, setSubjectoptions] = useState([]);
  const [Classoptions, setClassoptions] = useState([]);
  const [selectedUser_rep, setSelectedUser_rep] = useState(null);
  const [Invigilation_status, setInvigilation_status] = useState("");
  const center_id = localStorage.getItem("center_id");
  const token = localStorage.getItem("token");

  // Extract timetable ID from URL
  const timetableId = location.pathname.match(
    /\/Invigilation-attendance\/new\/(\d+)/
  )?.[1];
  console.log("id", timetableId);

  const redirectToLogin = () => {
    toast.warning("Please login first to access this page", {
      autoClose: 2000,
      onClose: () => (window.location.href = "/"),
    });
  };

  // Fetch timetable data if editing
  useEffect(() => {
    const fetchTimetable = async () => {
      if (!timetableId) return;

      try {
        const response = await fetch(`${serverUrl}/duty/${timetableId}`);
        if (!response.ok) throw new Error("Failed to fetch timetable");
        const data = await response.json();

        setInputValues(data.data);
      } catch (error) {
        console.error(error);
        toast.error("Failed to load timetable data");
      }
    };

    fetchTimetable();
  }, [timetableId]);

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch users
        const userRes = await fetch(`${serverUrl}/user_ids/${center_id}`);
        if (!userRes.ok) throw new Error("Failed to fetch users");
        const userData = await userRes.json();
        setUseroptions([
          { value: "None", label: "None" },
          ...userData.data.map((u) => ({ value: u.id, label: u.name })),
        ]);

        // Fetch subjects
        const subjectRes = await fetch(`${serverUrl}/subject_ids/${center_id}`);
        if (!subjectRes.ok) throw new Error("Failed to fetch subjects");
        const subjectData = await subjectRes.json();
        setSubjectoptions([
          { value: "None", label: "None" },
          ...subjectData.data.map((s) => ({ value: s.id, label: s.name })),
        ]);

        // Fetch classes
        const classRes = await fetch(`${serverUrl}/class_ids/${center_id}`);
        if (!classRes.ok) throw new Error("Failed to fetch classes");
        const classData = await classRes.json();
        setClassoptions(
          classData.data.map((c) => ({ value: c.id, label: c.name }))
        );
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load required data");
      }
    };

    fetchData();
  }, [center_id]);

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleStatusChange = (selectedOption) => {
    const status = selectedOption.value;
    setInvigilation_status(status);

    if (status === "Present" || status === "Late") {
      // For Present/Late, set replacement fields to "None"
      setSelectedUser_rep({ value: "None", label: "None" });
      setInputValues({
        ...inputValues,
        Invigilation_status: status,
        user_rep_id: "None",
      });
    } else {
      // For Absent or Replacement, reset user selection
      setSelectedUser_rep(null);
      setInputValues({
        ...inputValues,
        Invigilation_status: status,
        user_rep_id: null,
      });
    }
  };

  const handleReplacementUserChange = (selectedOption) => {
    setSelectedUser_rep(selectedOption);
    setInputValues({
      ...inputValues,
      user_rep_id: selectedOption?.value || null,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!inputValues.date) {
      toast.error("Please select a date");
      return;
    }

    if (!inputValues.Invigilation_status) {
      toast.error("Please select Invigilation status");
      return;
    }

    if (
      (inputValues.Invigilation_status === "Replacement" ||
        inputValues.Invigilation_status === "Absent") &&
      !inputValues.user_rep_id
    ) {
      toast.error(
        "Please select replacement Invigilation (or None if not applicable)"
      );
      return;
    }

    const formData = new FormData();
    formData.append("center_id", center_id);
    formData.append("duty_id", timetableId);
    formData.append("teacher_status", inputValues.Invigilation_status);
    formData.append("date", inputValues.date);
    formData.append("user_rep_id", inputValues.user_rep_id || "");
    formData.append("status", inputValues.status || 1);

    const toastId = toast.loading("Saving Invigilation attendance...");

    try {
      const response = await fetch(`${serverUrl}/add_invagilator_attendance`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        toast.update(toastId, {
          render: data.message || "Failed to save attendance",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });

        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        }
      } else {
        toast.update(toastId, {
          render: "Attendance saved successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });

        setTimeout(() => {
          navigate("/Invigilation-attendance");
        }, 1500);
      }
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: "Error occurred while saving attendance",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const showReplacementFields = () => {
    return (
      inputValues.Invigilation_status === "Replacement" ||
      inputValues.Invigilation_status === "Absent"
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3000} />
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {/* Timetable Information (Read-only) */}
                      <Grid item xs={12} className="formGridItem">
                        <div className="sectionTitle">
                          <Typography variant="subtitle1" fontWeight="bold">
                            Invigilator Information
                          </Typography>
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Invigilator</label>
                          <input
                            type="text"
                            value={inputValues.user_names || ""}
                            readOnly
                            className="read-only-input"
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Date</label>
                          <input
                            type="text"
                            value={inputValues.date || ""}
                            readOnly
                            className="read-only-input"
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Time</label>
                          <input
                            type="text"
                            value={inputValues.duty_time || ""}
                            readOnly
                            className="read-only-input"
                          />
                        </div>
                      </Grid>

                      {/* Attendance Section */}
                      <Grid item xs={12} className="formGridItem">
                        <div
                          className="sectionTitle"
                          style={{ marginTop: "20px" }}
                        >
                          <Typography variant="subtitle1" fontWeight="bold">
                            Attendance Details
                          </Typography>
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Date</label>
                          <input
                            type="date"
                            name="date"
                            value={inputValues.date || ""}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Status</label>
                          <StyledSelect
                            options={TSOptions}
                            name="Invigilation_status"
                            value={TSOptions.find(
                              (opt) =>
                                opt.value === inputValues.Invigilation_status
                            )}
                            onChange={handleStatusChange}
                            required
                            classNamePrefix="select"
                          />
                        </div>
                      </Grid>

                      {/* Replacement Section - Conditionally Rendered */}
                      {showReplacementFields() && (
                        <>
                          <Grid item xs={12} className="formGridItem">
                            <div
                              className="sectionTitle"
                              style={{ marginTop: "10px" }}
                            >
                              <Typography variant="subtitle1" fontWeight="bold">
                                {inputValues.Invigilation_status ===
                                "Replacement"
                                  ? "Replacement Details"
                                  : "Class Coverage Details"}
                              </Typography>
                            </div>
                          </Grid>

                          <Grid item xs={12} sm={6} className="formGridItem">
                            <div className="formInput">
                              <label>
                                {inputValues.Invigilation_status ===
                                "Replacement"
                                  ? "Replacement Invigilator"
                                  : "Coverage Invigilator"}
                              </label>
                              <StyledSelect
                                options={useroptions}
                                name="user_rep_id"
                                value={selectedUser_rep}
                                onChange={handleReplacementUserChange}
                                required
                                classNamePrefix="select"
                                placeholder="Select Invigilation or None"
                              />
                            </div>
                          </Grid>
                        </>
                      )}
                    </Grid>

                    {/* Action Buttons */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/Invigilation-attendance")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                      >
                        Save Attendance
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
    </ThemeProvider>
  );
};

export default InvigilationAttendanceNew;
